// extracted by mini-css-extract-plugin
export default {"wrap":"no-conversatins_wrap__GtE-M"};